import React from "react";

type Props = {
  scoring: any;
  result: any;
};

const LwaasPanel: React.FC<Props> = ({ scoring, result }) => {
  const max = Number(scoring?.max) || 125;
  const itemCount = Number(scoring?.itemCount) || 25;
  const domains = scoring?.domains || [];
  const lwaas = result?.lwaas;
  const total = Number(lwaas?.total) || 0;
  const answered = Number(lwaas?.answered) || 0;
  const band = result?.band;
  const circ = 2 * Math.PI * 86;
  const offset = circ * (1 - (answered ? Math.min(1, total / max) : 0));

  let bandClass = "band-none";
  let bandText = "Awaiting responses";
  if (answered && band?.tone === "high") {
    bandClass = "band-high";
    bandText = band.label || "High readiness";
  } else if (answered && band?.tone === "mod") {
    bandClass = "band-mod";
    bandText = band.label || "Moderate readiness";
  } else if (answered && band?.tone === "low") {
    bandClass = "band-low";
    bandText = band.label || "Low readiness";
  }
  if (answered && answered < itemCount) {
    bandText += ` · ${answered}/${itemCount} done`;
  }

  return (
    <div className="score-panel">
      <div className="gauge-wrap">
        <div className="gauge">
          <svg width="200" height="200" viewBox="0 0 200 200">
            <circle
              cx="100"
              cy="100"
              r="86"
              fill="none"
              stroke="#EFF3F2"
              strokeWidth="16"
            />
            <circle
              cx="100"
              cy="100"
              r="86"
              fill="none"
              stroke="var(--success)"
              strokeWidth="16"
              strokeLinecap="round"
              strokeDasharray={circ.toFixed(1)}
              strokeDashoffset={offset.toFixed(1)}
              style={{ transform: "rotate(-90deg)", transformOrigin: "center" }}
            />
          </svg>
          <div className="gauge-center">
            <div className="gauge-num">{answered ? total : 0}</div>
            <div className="gauge-max">/ {max}</div>
          </div>
        </div>
        <div className={`gauge-band ${bandClass}`}>{bandText}</div>
      </div>
      <div className="dbars">
        {domains.map((d: any, idx: number) => {
          const domain = (lwaas?.domains || []).find(
            (x: any) => x.id === d.sectionId,
          );
          const score = domain?.answered ? domain.score : null;
          const width =
            score != null && d.max ? Math.round((score / d.max) * 100) : 0;
          return (
            <div className="dbar-row" key={d.sectionId}>
              <div className="domain-num">{idx + 1}</div>
              <div className="dbar-label">{d.name}</div>
              <div className="dbar-track">
                <div className="dbar-fill" style={{ width: `${width}%` }} />
              </div>
              <div className="dbar-val">
                {score != null ? `${score}/${d.max}` : `-/${d.max}`}
              </div>
            </div>
          );
        })}
        <div className="score-foot">
          Interpretation bands (v2.0):{" "}
          <b style={{ color: "var(--good)" }}>High 82–{max}</b> ·{" "}
          <b style={{ color: "var(--warn)" }}>Moderate 41–81</b> ·{" "}
          <b style={{ color: "var(--danger)" }}>Low 0–40</b>. The scale lists{" "}
          {itemCount} items.
        </div>
      </div>
    </div>
  );
};

export default LwaasPanel;
